/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Transcript_Export_Preset_SavedInputs */



/**
* | output |
* | --- |
* | "Preset \"{name}\" saved successfully" |
*
* @param {Transcript_Export_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_saved = /** @type {((inputs: Transcript_Export_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Prereglage "${i?.name}" enregistre avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" erfolgreich gespeichert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" salvata correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предварительные настройки "${i?.name}" успешно сохранены.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El ajuste preestablecido "${i?.name}" se guardó correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`预设“${i?.name}”已成功保存`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プリセット「${i?.name}」が正常に保存されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" सफलतापूर्वक सहेज लिया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" salva com sucesso`)
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" saved successfully`)
});